<section class="contact-hero">
  <div class="container">
    <p class="eyebrow">{{ 'pages.contact.contact.eyebrow' | translate }}</p>
    <h1>{{ 'pages.contact.contact.title' | translate }}</h1>
    <p>{{ 'pages.contact.contact.subtitle' | translate }}</p>
  </div>
</section>

<section class="contact-page">
  <div class="container contact-grid">
    <aside class="contact-info">
      <h2>{{ 'pages.contact.contact.infoTitle' | translate }}</h2>
      <p>{{ 'pages.contact.contact.infoText' | translate }}</p>
      <div class="info-card"><span>⌖</span><div><strong>{{ 'pages.contact.contact.areaLabel' | translate }}</strong><p>{{ 'pages.contact.contact.areaValue' | translate }}</p></div></div>
      <p class="response-time">{{ 'pages.contact.contact.responseTime' | translate }}</p>
    </aside>

    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm)" class="contact-form">
      <h2>{{ 'pages.contact.contact.formTitle' | translate }}</h2>
      <div class="two-columns">
        <label>{{ 'pages.contact.contact.name' | translate }}<input name="name" [(ngModel)]="model.name" required maxlength="120" autocomplete="name"></label>
        <label>{{ 'pages.contact.contact.email' | translate }}<input type="email" name="email" [(ngModel)]="model.email" required email maxlength="190" autocomplete="email"></label>
      </div>
      <div class="two-columns">
        <label>{{ 'pages.contact.contact.phone' | translate }}<input type="tel" name="phone" [(ngModel)]="model.phone" maxlength="40" autocomplete="tel"></label>
        <label>{{ 'pages.contact.contact.subject' | translate }}<input name="subject" [(ngModel)]="model.subject" required maxlength="180"></label>
      </div>
      <label>{{ 'pages.contact.contact.message' | translate }}<textarea class="contact-main-message" name="message" [(ngModel)]="model.message" required minlength="10" maxlength="5000" rows="7"></textarea></label>
      <input class="website-field" name="website" [(ngModel)]="model.website" tabindex="-1" autocomplete="off" aria-hidden="true">
      @if (success()) { <p class="feedback success">{{ 'pages.contact.contact.success' | translate }}</p> }
      @if (error()) { <p class="feedback error">{{ error() | translate }}</p> }
      <button type="submit" [disabled]="contactForm.invalid || sending()">
        {{ (sending() ? 'pages.contact.contact.sending' : 'pages.contact.contact.submit') | translate }}
      </button>
      <small>{{ 'pages.contact.contact.privacy' | translate }}</small>
    </form>
  </div>
</section>
